import {
  filterBySignature,
  getMatchVariants,
} from "@/components/expression/utils/switch-notations/getMatchVariants";
import { substituteCaptures } from "@/components/expression/utils/switch-notations/substituteCaptures";

import { groupSuggestions } from "../utils";

import type { SingleSuggestion, SuggestionProvider } from "../types";
import type { NodeModel } from "@/models/nodes/types";

function buildVariantSuggestions(nodes: NodeModel[]): SingleSuggestion<"expression">[] {
  const notations = filterBySignature(nodes);
  if (notations.length === 0) {
    return [];
  }

  return getMatchVariants(nodes, notations).flatMap((match) =>
    match.variants
      .map<SingleSuggestion<"expression"> | null>((variant) => {
        const nodesJson = substituteCaptures(variant.nodesJson, match.captures);
        if (!nodesJson) {
          return null;
        }

        return {
          type: "single",
          item: {
            type: "expression",
            symbol: "",
            nodesJson,
          },
          action: {
            type: "insert-expression",
            nodesJson,
            deleteSelection: true,
          },
          trackingId: "notation",
          popupGroup: "hints",
          priority: 10,
        };
      })
      .filter(Boolean),
  );
}

export const notationSuggestionsProvider: SuggestionProvider<"notation"> = {
  type: "notation",
  search: (_str, doc) => {
    const { selection } = doc.cursorContext();

    if (!selection.isMathOnlySelection) {
      return [];
    }

    const suggestions = buildVariantSuggestions(selection.selectedNodes);
    if (suggestions.length === 0) {
      return [];
    }

    const [first] = suggestions;

    const parent: SingleSuggestion<"expression"> = {
      ...first,
      icon: "Notation",
      item: {
        ...first.item,
        intlName: "notation.changeNotation",
        nodesJson: undefined,
        displayName: undefined,
      },
      forceIcon: true,
      trackingId: undefined,
      nestedKey: "notations",
      nestedItems: groupSuggestions("", suggestions),
    };

    return [[parent]];
  },
};
